import cx from "classnames";

import { Text } from "../../Text";

import styles from "./PaginationTotalCount.module.scss";

export const PaginationTotalCount = ({
  itemRangeText,
  className,
}: {
  itemRangeText: string;
  className?: string;
}) => {
  const paginationTotalCountClassName = cx(
    styles["pagination-total-count"],
    className,
  );
  return (
    <Text
      size="small"
      className={paginationTotalCountClassName}
      aria-hidden="true"
    >
      {itemRangeText}
    </Text>
  );
};
